import type { ActionReducerMap } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import {
  createUsageQuestionnaireReducer,
  type UsageQuestionnaireState,
} from '@innogy/common-ui/sales';

import {
  solarPanelsFunnelReducer,
  solarPanelsFunnelKey,
  type SolarPanelsFunnelState,
} from './solar-panels-funnel/solar-panels-funnel.reducer';
import {
  solarPanelsOrderFormReducer,
  solarPanelsOrderFormKey,
  type SolarPanelsOrderFormState,
} from './solar-panels-order-form/solar-panels-order-form.reducer';
import {
  solarPanelsResultOverviewReducer,
  solarPanelsResultOverviewKey,
  type SolarPanelsResultOverviewState,
} from './solar-panels-result-overview/solar-panels-result-overview.reducer';
import {
  solarPanelsApiKey,
  solarPanelsAPIReducer,
  type SolarPanelsAPIState,
} from './solar-panels-api/solar-panels-api.reducer';
import {
  solarPanelsSuitabilityCheckReducer,
  type SolarPanelsSuitabilityCheckState,
} from './solar-panels-suitability-check/solar-panels-suitability-check.reducer';
import {
  solarPanelsProductOverviewKey,
  solarPanelsProductOverviewReducer,
  type SolarPanelsProductOverviewState,
} from './solar-panels-products/solar-panels-product-overview.reducer';
import { solarPanelsSuitabilityCheckKey } from './solar-panels-suitability-check/form-ids';
import {
  solarPanelsWizardKey,
  solarPanelsWizardReducer,
  type SolarPanelsWizardState,
} from './solar-panels-wizard/solar-panels-wizard.reducer';

export const fehSolarPanelsStoreSelectorKey = 'feh-solar-panels';
export const SOLAR_USAGE_QUESTIONNAIRE_ID = 'solarpanels-usage-wizard';

export interface FehSolarPanelsState {
  readonly [solarPanelsFunnelKey]: SolarPanelsFunnelState;
  readonly [solarPanelsWizardKey]: SolarPanelsWizardState;
  readonly [solarPanelsSuitabilityCheckKey]: SolarPanelsSuitabilityCheckState;
  readonly [solarPanelsProductOverviewKey]: SolarPanelsProductOverviewState;
  readonly [solarPanelsOrderFormKey]: SolarPanelsOrderFormState;
  readonly [solarPanelsApiKey]: SolarPanelsAPIState;
  readonly [solarPanelsResultOverviewKey]: SolarPanelsResultOverviewState;
  readonly UsageQuestionnaireForm: UsageQuestionnaireState;
}

export const reducers: ActionReducerMap<FehSolarPanelsState> = {
  [solarPanelsFunnelKey]: solarPanelsFunnelReducer,
  [solarPanelsWizardKey]: solarPanelsWizardReducer,
  [solarPanelsSuitabilityCheckKey]: solarPanelsSuitabilityCheckReducer,
  [solarPanelsProductOverviewKey]: solarPanelsProductOverviewReducer,
  [solarPanelsOrderFormKey]: solarPanelsOrderFormReducer,
  [solarPanelsApiKey]: solarPanelsAPIReducer,
  [solarPanelsResultOverviewKey]: solarPanelsResultOverviewReducer,
  UsageQuestionnaireForm: createUsageQuestionnaireReducer(
    SOLAR_USAGE_QUESTIONNAIRE_ID
  ),
};

export const selectFehSolarPanelsState =
  createFeatureSelector<FehSolarPanelsState>(fehSolarPanelsStoreSelectorKey);
